import { render, staticRenderFns } from "./CrowdHistory.vue?vue&type=template&id=1c9d733a&scoped=true"
import script from "./CrowdHistory.vue?vue&type=script&lang=js"
export * from "./CrowdHistory.vue?vue&type=script&lang=js"
import style0 from "./CrowdHistory.vue?vue&type=style&index=0&id=1c9d733a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9d733a",
  null
  
)

export default component.exports